enum ReservedUUID {
  SystemPropertyGroup = "00739aed-53d2-a7a1-b20c-c4a4175ff003",
  MyContentRoot = "00739aed-53d2-a7a1-b20c-c4a4175ff000",
  ContentModelAllowedAll = "11111111-1111-1111-1111-111111111111",
}

export default ReservedUUID;
